<template>
  <span>
    <div class="boss-scout-confirm-container">
      <div
        class="boss-scout-confirm-header pega-break"
        data-test="subject"
      >件名：{{ subject }}</div>
      <div class="boss-scout-confirm-body pega-pre-wrap">
        <div class="boss-scout-confirm-contents">
          <div class="boss-scout-confirm-contents-text clearfix">
            <div
              class="boss-scout-confirm-contents-sentence float-left pega-break"
              data-test="body"
              v-html="$sanitize(renderBody)"
            />
          </div>
          <div class="boss-scout-confirm-bonus">
            <template v-for="(specialFavor, i) in specialFavorsMaster">
              <span
                v-if="specialFavorIds.includes(specialFavor.id)"
                :key="i"
                v-tooltip="{ content: specialFavor.description}"
                :data-test="'special-favor-id-' + i"
                class="boss-bonus-check-text boss-check-true"
              >{{ specialFavor.name }}</span>
            </template>
          </div>
        </div>
      </div>
      <div
        v-if="reservationDate"
        class="boss-scout-confirm-footer"
      >
        <div data-test="reservation-name">
          スカウト送信予約名：{{ reservationName }}
        </div>
        <div data-test="reservation-date">
          送信日時：{{ reservationDate }}
        </div>
      </div>
    </div>
    <form-button-area>
      <form-back-button
        data-test="back-button"
        @back="$emit('switching-state', true)"
      />
      <form-confirm-button
        :is-disabled="isScoutSendDisabled"
        :submit-label="reservationDate ? 'この内容で送信予約をする' : 'この内容で送信する'"
        data-test="confirm-button"
        @submit-event="$emit('register-scout-messages')"
      />
    </form-button-area>
  </span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import util from '@/lib/util'
import FormButtonArea from '@/components/atoms/FormButtonArea'
import FormConfirmButton from '@/components/atoms/FormConfirmButton'
import FormBackButton from '@/components/atoms/FormBackButton'

export default {
  components: {
    FormButtonArea,
    FormConfirmButton,
    FormBackButton
  },
  props: {
    subject: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    specialFavorIds: {
      type: Array,
      required: true
    },
    isScoutSendDisabled: {
      type: Boolean,
      required: true
    },
    reservationDate: {
      type: String,
      default: ''
    },
    reservationName: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      specialFavorsMaster: 'specialFavorsMaster'
    }),
    renderBody () {
      return util.replaceAddressAndUrlLink(this.body)
    }
  },
  created () {
    this.storeMaster('specialFavors')
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ])
  }
}
</script>
